"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.globalLocationType = exports.dataType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var dataType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string,
  useCurrentLocationLabel: _propTypes["default"].string,
  inputLocationLabel: _propTypes["default"].string
});
exports.dataType = dataType;
var globalLocationType = _propTypes["default"].shape({
  searchValue: _propTypes["default"].string,
  userLocation: _propTypes["default"].string,
  stateCode: _propTypes["default"].string
});
exports.globalLocationType = globalLocationType;